import { I as r } from "../../constants-DeVuDy8J.js";
import { openBlock as l, createElementBlock as d, normalizeClass as o, createElementVNode as n } from "vue";
import { _ as s } from "../../_plugin-vue_export-helper-CHgC5LLL.js";
const c = {
  name: "DtIconTools",
  props: {
    /**
     * The size of the icon.
     * @values 100, 200, 300, 400, 500, 600, 700, 800
     */
    size: {
      type: String,
      default: "500",
      validator: (e) => Object.keys(r).includes(e)
    },
    /**
     * The label of the icon as read out by a screenreader. Leave this unset if your icon is purely presentational
     */
    ariaLabel: {
      type: String,
      default: void 0
    }
  },
  /**
  * @TODO: Remove this emit once the icons migration is complete,
  * they will no longer need this event.
  * */
  emits: ["loaded"],
  computed: {
    iconSizeClass() {
      return r[this.size];
    },
    ariaHidden() {
      return this.ariaLabel ? "false" : "true";
    },
    dataQA() {
      return this.$attrs["data-qa"] ?? "dt-icon";
    }
  },
  created() {
    this.$emit("loaded");
  }
}, m = ["aria-label", "data-qa", "aria-hidden"];
function u(e, t, i, _, f, a) {
  return l(), d("svg", {
    "aria-label": i.ariaLabel,
    class: o([a.iconSizeClass, "d-icon d-icon--tools"]),
    "data-qa": a.dataQA,
    "aria-hidden": a.ariaHidden,
    role: "img",
    "data-name": "Tools",
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 12 12"
  }, [...t[0] || (t[0] = [
    n("path", {
      fill: "currentColor",
      "fill-rule": "evenodd",
      d: "M8.279 1.514A2.5 2.5 0 0 0 5.72 5.029a.5.5 0 0 1-.102.56L2.164 9.042a.56.56 0 0 0 .792.793L6.411 6.38a.5.5 0 0 1 .56-.102 2.5 2.5 0 0 0 3.515-2.558L9.2 5.007a1 1 0 0 1-1.4 0l-.004-.004-.803-.803a1 1 0 0 1 0-1.4l.003-.004L8.28 1.514ZM7.37.554A3.5 3.5 0 0 1 9.44.81a.5.5 0 0 1 .148.81L7.706 3.5l.793.794 1.881-1.882a.5.5 0 0 1 .81.148 3.5 3.5 0 0 1-4.304 4.76l-3.223 3.224a1.56 1.56 0 1 1-2.208-2.207L4.68 5.112A3.5 3.5 0 0 1 7.37.555Z",
      "clip-rule": "evenodd"
    }, null, -1)
  ])], 10, m);
}
const b = /* @__PURE__ */ s(c, [["render", u]]);
export {
  b as default
};
//# sourceMappingURL=tools.js.map
